import { Link } from "react-router-dom";
import { ShieldCheck, ChevronRight } from "lucide-react";

/** Reusable trust blurb pointing to /about-scott. Drop into any page. */
export default function AboutScottBlurb({
  heading = "Personal Help from Scott",
  text = "With over 15 years in the car business, Scott helps Central Ohio drivers compare new and used options, ask better questions, and make the process less stressful.",
  ctaLabel = "Meet Scott",
  className = "",
  testId = "about-scott-blurb",
}) {
  return (
    <div
      className={`bg-white border border-[#D9E1EA] rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between min-w-0 ${className}`}
      data-testid={testId}
    >
      <div className="flex items-start sm:items-center gap-3 min-w-0">
        <div className="shrink-0 w-10 h-10 rounded-xl bg-[var(--ssc-blue)]/10 text-[var(--ssc-blue)] flex items-center justify-center">
          <ShieldCheck size={20} />
        </div>
        <div className="min-w-0">
          <h3 className="text-base sm:text-lg font-black text-[#081426]">{heading}</h3>
          <p className="text-sm text-[var(--ssc-ink-2)] mt-1 max-w-2xl">{text}</p>
        </div>
      </div>
      <Link
        to="/about-scott"
        className="ssc-btn ssc-btn-primary text-sm shrink-0 inline-flex items-center gap-1"
        data-testid={`${testId}-cta`}
      >
        {ctaLabel} <ChevronRight size={14} />
      </Link>
    </div>
  );
}
